import Message from "./Message";
import MessageType from "./MessageType";
import chatDataCenter from "../chatDataCenter";
import axios from '../../utils/axios.js'
import moment from "moment";
import bus from "../../utils/bus";

const ChatRoom = function () {
    this._init_();
};
ChatRoom.prototype = {
    constructor: ChatRoom,
    _init_: function () {
        this.welcomeFlag =false;
        this.sessionId =null
        this.sessionType =null
        this.beforeType =null
        this.messages = [];
        this.inputting=""
        this.customerEvaluate = null;
        this.waitTime =0;
        this.totalTimes= 0; //累计回答不了用户问题
        this.changeTimes= false; //修改回答不了用户问题次数
        this.continuityTimes= 0;//连续回答不了用户问题
    },
    resetChatRoom:function () {
        this.id = null;
        this.sessionId = null;
        this.sessionPid = null;
        this.sessionType = null;
        this.beforeType = null;
        this.consultId = null;
        this.userId = null;
        this.beginTime = null;
        this.allotTime = null;
        this.evaluateModel = null; //评价模式 枚举
        this.arrangeFlag = 1;// 是否会话整理1:未整理2已整理
        this.transferFlag = null; //转接后状态(1:转接中2:他人转接3，转接失败)
        this.queueFlag=0; //会话排队类型(1:客服2：技能组)
        this.queuePrefix=null; //排队前缀(7:正常排队 4：插队)
        this.queueTime= null; //排队时间
        this.groupId = null;
        this.groupName= null;
        this.totalTimes= 0; //累计回答不了用户问题
        this.changeTimes= false; //修改回答不了用户问题次数
        this.continuityTimes= 0;//连续回答不了用户问题
        this.closureTime = null; //历史记录中
        this.closureReason = null; //历史记录中
        this.customerEvaluate = null; //历史记录中
        this.unReadNum = 0;
        this.waitTime =0;
        this.senderType = 0;// 0:没有最后一条消息 1:最后一条消息是顾客发送的 2:最后一条消息是客服发送的
        this.inputting= "";
        bus.$emit("changeEdit",'');
        if(this.waitTimeFn&&this.waitTimeFn!=undefined){
            clearTimeout(this.waitTimeFn);
        }
    },
    refreshChatRoom:function (obj,vue) {
        if (obj) {
            chatDataCenter.evaluation.sessionId=obj.sessionId
            chatDataCenter.leaveMessage.sessionId=obj.sessionId
            chatDataCenter.evaluation.customerEvaluate=0
            chatDataCenter.evaluation.show=false
            chatDataCenter.evaluation.closeType='6'
            if(obj.id!=undefined){ this.id = obj.id}
            if(obj.sessionId!=undefined){ this.sessionId = obj.sessionId}
            if(obj.sessionPid!=undefined){ this.sessionPid = obj.sessionPid}
            if(obj.sessionType!=undefined){ this.sessionType = obj.sessionType}
            if(obj.beforeType!=undefined){ this.beforeType = obj.beforeType}
            if(obj.companyId!=undefined){ this.companyId = obj.companyId}
            if(obj.customerId!=undefined){ this.customerId = obj.customerId}
            if(obj.customerChannelId!=undefined){ this.customerChannelId = obj.customerChannelId}
            chatDataCenter.customer.refreshSessionInfo(obj)
            if(obj.consultId!=undefined){ this.consultId = obj.consultId}
            if(obj.userId!=undefined){ this.userId = obj.userId}
            if(obj.beginTime!=undefined){ this.beginTime = obj.beginTime}
            if(obj.allotTime!=undefined){ this.allotTime = obj.allotTime}
            if(obj.evaluateModel!=undefined){ this.evaluateModel = obj.evaluateModel} //评价模式 枚举
            if(obj.arrangeFlag!=undefined){ this.arrangeFlag = obj.arrangeFlag==2?2:1;}// 是否会话整理1:未整理2已整理
            if(obj.transferFlag!=undefined){ this.transferFlag = obj.transferFlag}//转接后状态(1:转接中2:他人转接3，转接失败)
            if(obj.queueFlag!=undefined){ this.queueFlag = obj.queueFlag} //会话排队类型(1:客服2：技能组)
            if(obj.queuePrefix!=undefined){ this.queuePrefix = obj.queuePrefix} //排队前缀(7:正常排队 4：插队)
            if(obj.queueTime!=undefined){ this.queueTime = obj.queueTime} //排队时间
            if(obj.groupId!=undefined){ this.groupId = obj.groupId}
            if(obj.groupName!=undefined){ this.groupName = obj.groupName}
            if(obj.totalTimes!=undefined&&obj.totalTimes!=null){  this.totalTimes= obj.totalTimes}//累计回答不了用户问题
            if(obj.continuityTimes!=undefined&&obj.continuityTimes!=null){  this.continuityTimes= obj.continuityTimes}//连续回答不了用户问题
            bus.$emit("changeEdit",'');
            //历史记录中
            if(obj.closureTime!=undefined){ this.closureTime = obj.closureTime}
            if(obj.closureReason!=undefined){ this.closureReason = obj.closureReason}
            if(obj.customerEvaluate!=undefined){ this.customerEvaluate = obj.customerEvaluate}
            if(obj.unReadNum!=undefined&&obj.unReadNum!=null){  this.unReadNum= obj.unReadNum}
            if(typeof obj.waitTime === "undefined" || obj.waitTime === null || obj.waitTime === ""){
                this.waitTime =0;
            }else {
                this.waitTime = parseInt(obj.waitTime/1000);// 已等待时间
            }
            this.senderType = 0;// 0:没有最后一条消息 1:最后一条消息是顾客发送的 2:最后一条消息是客服发送的
            if(obj.senderType!=undefined&&obj.senderType!=null){
                this.senderType =obj.senderType;
            }
            this.inputting= "";
            if(this.waitTimeFn&&this.waitTimeFn!=undefined){
                clearTimeout(this.waitTimeFn);
            }
            if(this.closureTime==null){
                this.compareMin(vue)
            }
            if(this.sessionType==1){
                chatDataCenter.apiInitRobot(this.welcomeFlag);
            }
        }
    },
    /**
     * 等待时间初期化
     */
    waitTimeReset:function () {
        if(this.waitTimeFn){
            clearTimeout(this.waitTimeFn);
        }
        this.waitTime = 0;
    },

    compareMin:function () {
        var _this = this;
        if(_this.closureTime==null&&this.queueFlag==0&&chatDataCenter.sessionSetInfo!=null){
            this.waitTimeFn = setInterval(function () {
                _this.waitTime++;
                var replyMin=null;
                var replyMessage=null;

                //最后一条消息顾客发送的定时器
                if (_this.senderType==1){
                    replyMin=chatDataCenter.sessionSetInfo.userReplyMin;
                    replyMessage=chatDataCenter.sessionSetInfo.userReplyMessage;
                }
                //最后一条消息客服发送的定时器
                if (_this.senderType==2){
                    replyMin=chatDataCenter.sessionSetInfo.customerReplyMin;
                    replyMessage=chatDataCenter.sessionSetInfo.customerReplyMessage;
                }
                if (replyMin&&replyMin!=0&&replyMessage){
                    if( _this.waitTime==(replyMin*60)){
                        if((_this.sessionType=='2'||_this.sessionType==2)||(_this.senderType==2)){
                            chatDataCenter.notifyMessage('S','S3',replyMessage)
                        }
                    }
                  if (_this.waitTime == 1 * 60) {
                    if (this.sessionType == "2" || this.sessionType == 2 || _this.senderType == 2){
                      const messageDirection = chatDataCenter.chatRoom.messages.filter(item => {
                        return item.messageDirection === "C"
                      });
                      if(messageDirection.length > 0){
                        console.log('客户问过问题且超时回复========');

                      }
                    }
                  }
                }
            }, 1000);
        }

    },
    /**
     * 等待时间重新计时
     */
    waitTimeStart:function (message,senderType) {
        // 0:没有最后一条消息 1:最后一条消息是顾客发送的 2:最后一条消息是客服发送的
        if(senderType==1){
            //顾客发送发送,客服超时回复
            if (this.senderType!=1){
                this.waitTimeReset();
                this.senderType = senderType;
                this.compareMin();
            }
        }
        if(senderType==2&&this.senderType!=2){
            this.waitTimeReset();
            //为客服发送,客户超时回复
            this.senderType = senderType;
            this.compareMin();
        }
    },
    /**
     * 消息状态变更
     * @param messageId
     * @param status
     */
    messageStatusChange:function (messageId, messageStatus) {
        var message = this.getMessageByMessageId(messageId);
        if(message !== null){
            message.messageStatus = messageStatus;
        }
    },
    getAnswer:function (messageContent) {
        if (typeof messageContent  == 'string'){
            try {
                var obj=JSON.parse(messageContent);
                if(typeof obj == 'object' && obj ){
                    var data = JSON.parse(messageContent);
                    return data.answer;
                }else{
                    return messageContent;
                }
            } catch(e) {
                return messageContent;
            }
        }
    },
    deleteMessage:function (message) {
        if( message.messageType==MessageType.R){
            var index=this.messages.findIndex(d=>d.messageType==MessageType.L);
            if (index!=-1){
                this.messages.splice(index, 1);
            }
        }
    },

    sortMessage:function (message) {
        if( message.messageType==MessageType.R){
            var index=this.messages.findIndex(d=>d.messageType==MessageType.L);
            if (index!=-1){
                this.messages.sort(function (a,b) {
                    if (a.messageType=== MessageType.L&&b.messageType!== MessageType.L){
                        return 1;
                    }
                    if (b.messageType=== MessageType.L&&a.messageType!== MessageType.L){
                        return -1;
                    }
                });
            }
        }
    },

    /**
     * 收到消息
     * @param message {Message}
     */
    receiveMessage:function (vue,message) {
        if(typeof message === undefined || message === null){
            return false;
        }

        this.deleteMessage(message);
        if (message.messageType=='R'){
            chatDataCenter.chatRoom.changeTimes= false;
            if (this.getAnswer(message.messageContent)=='#转人工#'){
                chatDataCenter.transferStaffSession(vue,2)
                return false;
            }
        }
        var is_exist = false;
        if(message.messageId!=undefined&&message.messageId!=null){
            for(var i = 0; this.messages != null && i < this.messages.length; i++){
                if(message.messageId === this.messages[i].messageId){
                    is_exist = true;
                    break;
                }
            }
        }
        if(!is_exist){
          let answers = message.messageContent;
          if(chatDataCenter.isJSON(answers)){
            let answerJson = JSON.parse(answers);
            if (
              answerJson.plainText && answerJson.plainText.length > 160 && chatDataCenter.chatTerminal!='WEB' && !chatDataCenter.isJSON(answerJson.answer)) {
              message.isHasOpen = true;
              message.height = "245px";
            }

            if(answerJson.mainQuestion === "qizhi_welcome"){
              chatDataCenter.pushHotPoint();
            }

              /* 处理json类型答案-需要再处理完answer后重新生成新的answerMessage */
              if (answerJson.answer && chatDataCenter.isJSON(answerJson.answer)){
                  const jsonContent = JSON.parse(answerJson.answer);
                  answerJson.answer = jsonContent.data.guide;
                  /* json类型答案-message添加json类型 */
                  message.answerType = 'json'
                  message.messageContent = JSON.stringify(answerJson)
              }
          }
            message.sendTime=new Date().getTime()
            this.messages.push(message);
            this.sortMessage(message);
            chatDataCenter.showSkeleton = false;
            if (MessageType.I==message.messageType||MessageType.V==message.messageType){
                chatDataCenter.scrollToBottom("2");
            }else {
                chatDataCenter.scrollToBottom("1");
            }
            if(message.messageDirection=='U'){
                this.unReadNum++;
                if(chatDataCenter.set.windowFlag=='1'){
                    this.readMessage(message.messageId);
                }
                this.waitTimeStart(message,2);
                chatDataCenter.audioPlayer()
                return true;
            }
            chatDataCenter.audioPlayer()
            return false;
        }
        return false;
    },

    /**
     * 获取时间最早的一条消息
     */
    getForemostMessage:function () {
        if(this.messages === null || this.messages.length === 0){
            return null;
        }
        var e=this.messages.find(d=>d.messageId!=null)
        return e==undefined?null:e;
    },

    /**
     * 加载当前会话的历史聊天记录
     */
    loadHistoryMessages:function (vue,sessionId,callback) {
        var _this = this;
        var foremostMessage = this.getForemostMessage();
        axios.post("/chatHistoryCustomer/getHistoryByCustomerChannelId",{
            customerChannelId:chatDataCenter.customer.customerChannelId,
            sessionId:sessionId,
            messageId:foremostMessage == null ? "" : foremostMessage.messageId,
            rows:20
        }, function (response) {
            if(response.code==0){
                if(response.data !== null && response.data.length > 0){
                    for(var i = 0;  i < response.data.length; i++){
                        var message = new Message(response.data[i]);
                        let answers = message.messageContent;
                        if (chatDataCenter.isJSON(answers)) {
                          let answerJson = JSON.parse(answers);
                          if (answerJson.plainText && answerJson.plainText.length > 160 && chatDataCenter.chatTerminal !='WEB' ) {
                            message.isHasOpen = true;
                            message.height = "245px";
                          }
                        }
                        _this.messages.unshift(message);
                      chatDataCenter.showSkeleton = false;
                    }
                }else{
                    chatDataCenter.isLoadMessage = false;
                }

            }else{
                if(vue){
                    vue.$messageBox.Error({message:response.msg,duration:3000});
                }else{
                    console.log("加载历史聊天消息失败");
                }
            }
            if (callback){
                callback(response)
            }
        });
    },

    /**
     * 加载未读消息
     */
    loadUnReadMessage:function (vue) {
        var _this = this;
        axios.post("/chatHistoryCustomer/queryUnreadMessageByCustomer", {
            customerChannelId:chatDataCenter.customer.customerChannelId,
            sessionId:this.sessionId
        }, function (response) {
            if(response.code==0){
                if(response.data != null && response.data.length > 0){
                    for(var i = 0; i < response.data.length; i++){
                        _this.messages.push(new Message(response.data[i]));
                    }
                    _this.readMessages();
                }
            }else{
                if(vue){
                    _this.$messageBox.Error({message:response.msg,duration:3000});
                }else{
                    console.log("加载未读消息失败");
                }
            }
        });
    },


    /**
     * 给这个会话发送消息(发送待输入区域的内容)
     */
    sendMessage:function (questionSource) {
        if(this.inputting === null || this.inputting === "" ||this.sessionId==null){
            return;
        }
        this.sendMessageByContent(JSON.parse(JSON.stringify(this.inputting)),questionSource)
        this.inputting = "";
    },

    /**
     * 给这个会话发送消息(发送指定内容)
     */
    sendMessageByContent:function (content,questionSource) {
        if(typeof content == 'undefined' ||content === null || content === ""||this.sessionId==null){
            return;
        }
        var name=chatDataCenter.customer.nickName
        if(name==null||name==''){
            name='访客'+chatDataCenter.customer.customerCode
        }
        var avatar=chatDataCenter.customer.avatar
        if(avatar==null||avatar==''){
            avatar=chatDataCenter.linkInfo.userAvator
        }
        var bindId=(chatDataCenter.robotInfo!=null&&chatDataCenter.robotInfo.bindId!='')?chatDataCenter.robotInfo.bindId:''
        var message = new Message({
            messageId :this.createMessageID(),
            sessionId :this.sessionId,
            customerId :chatDataCenter.customer.customerId,
            customerChannelId :chatDataCenter.customer.customerChannelId,
            companyId :chatDataCenter.customer.companyId,
            messageDirection:'C',
            messageType : MessageType.T, //T:文本 I:图片 V:视频 F:文件 S1:系统消息(发送给顾客) S2:系统消息(发送给客服) R:机器人回复消息
            messageStatus : 0,//-1:发送失败0:发送中10:未读 20:已读 30:离线:40撤回
            messageContent : content,
            messageContentSimple :"",
            senderId :chatDataCenter.customer.customerChannelId,
            senderNickname : name,
            senderAvatar : avatar,
            sendTime : new Date().getTime(),//发送时间
            recallTime : null,//撤回时间
            readTime : null,//已读时间
            bindId : bindId,//机器人id
            robotName : chatDataCenter.linkInfo.robotName,//机器人客服名称
            robotAvatar : chatDataCenter.linkInfo.robotAvator,//机器人客服头像
            questionSource:questionSource
        });
        this.messages.push(message);
        chatDataCenter.notifyMessage('U','L','Loading')

        chatDataCenter.scrollToBottom("1")
        chatDataCenter.member_sdk.sendMessage(message, function () {
            // 发送成功回调
            message.messageStatus = 10;
        }, function () {
            // 发送失败回调
            message.messageStatus = -1;
        });
        this.waitTimeStart(message,1);
    },
    sendMessageInfoBeforeUpload:function(sendType){
        if(this.sessionId==null){
            return;
        }
        var name=chatDataCenter.customer.nickName
        if(name==null||name==''){
            name='访客'+chatDataCenter.customer.customerCode
        }
        var avatar=chatDataCenter.customer.avatar
        if(avatar==null||avatar==''){
            avatar=chatDataCenter.linkInfo.userAvator
        }
        var messageType='';
        var scrollType='1';
        if(sendType=="file"){
            messageType=MessageType.F;
        }else if(sendType=="img"){
            scrollType='2';
            messageType=MessageType.I;
        }else if(sendType=="video"){
            scrollType='2';
            messageType=MessageType.V;
        }
        var bindId=(chatDataCenter.robotInfo!=null&&chatDataCenter.robotInfo.bindId!='')?chatDataCenter.robotInfo.bindId:''
        var messageId=this.createMessageID();
        var message = new Message({
            messageId :messageId,
            sessionId :this.sessionId,
            customerId :chatDataCenter.customer.customerId,
            customerChannelId :chatDataCenter.customer.customerChannelId,
            companyId :chatDataCenter.customer.companyId,
            messageDirection:'C',
            messageType : messageType, //T:文本 I:图片 V:视频 F:文件 S1:系统消息(发送给顾客) S2:系统消息(发送给客服) R:机器人回复消息
            messageStatus : 0,//-1:发送失败0:发送中10:未读 20:已读 30:离线:40撤回
            messageContent :'',
            mediaUrl : '',
            messageContentSimple :"",
            senderId :chatDataCenter.customer.customerChannelId,
            senderNickname : name,
            senderAvatar : avatar,
            sendTime : new Date().getTime(),//发送时间
            recallTime : null,//撤回时间
            readTime : null,//已读时间
            bindId : bindId,//机器人id
            robotName : chatDataCenter.linkInfo.robotName,//机器人客服名称
            robotAvatar : chatDataCenter.linkInfo.robotAvator,//机器人客服头像
            sendFileStatus:0,//0:上传中,1:上传成功，2:上传失败
        });
        this.messages.push(message);
        chatDataCenter.scrollToBottom(scrollType)
        return messageId;
    },

    /**
     * 发送图片文件视频消息
     */
    sendMessageFile:function (fileObj,messageId) {
        if(this.sessionId==null){
            return;
        }
        var message=this.getMessageByMessageId(messageId);
        message.messageContent=JSON.stringify(fileObj);
        message.mediaUrl=fileObj.url;
        message.sendFileStatus=1;
        this.setMessageByMessageId(messageId,message);

        if(MessageType.F==message.messageType){
            chatDataCenter.scrollToBottom("1")
        }else {
            chatDataCenter.scrollToBottom("2")
        }

        chatDataCenter.member_sdk.sendMessage(message, function () {
            // 发送成功回调
            message.messageStatus = 10;
        }, function () {
            // 发送失败回调
            message.messageStatus = -1;
        });
        this.waitTimeStart(message,1);
    },


    readMessage:function (messageId) {
        var message = this.getMessageByMessageId(messageId);
        if(message != null && message.messageStatus == 10 &&
            ((message.messageType != 'R')||(message.messageType == 'R'))){
            this.unReadNum--;
            chatDataCenter.member_sdk.MBR_Response(message.id,this.sessionId,messageId);
        }
    },
    readMessages:function () {
        this.unReadNum = 0;
        if(this.sessionId!=undefined&&this.sessionId!=null){
            chatDataCenter.member_sdk.MBRA_Response(this.sessionId);
        }
    },
    getMessageByMessageId:function (messageId) {
        if(typeof messageId === 'undefined' || messageId === null || messageId === ''){
            return null;
        }
        if(this.messages === null || this.messages.length === 0){
            return null;
        }
        for(var i = 0; i < this.messages.length; i++){
            if(this.messages[i].messageId === messageId){
                return this.messages[i];
            }
        }
        return null;
    },
    setMessageByMessageId:function (messageId,data) {
        if(typeof messageId === 'undefined' || messageId === null || messageId === ''){
            return null;
        }
        if(this.messages === null || this.messages.length === 0){
            return null;
        }
        for(var i = 0; i < this.messages.length; i++){
            if(this.messages[i].messageId === messageId){
                this.messages[i].messageContent=data.messageContent;
                this.messages[i].mediaUrl=data.mediaUrl;
                this.messages[i].sendFileStatus=data.sendFileStatus==undefined?'':data.sendFileStatus;
                return this.messages[i];
            }
        }
        return null;
    },
    /**
     * 获取等待时间并格式化
     */
    getWaitTime:function () {
        if(this.waitTime < 60){
            return this.waitTime < 10 ? "00:0" + this.waitTime : "00:"+this.waitTime;
        }else if(this.waitTime < 60*60){
            var du = moment.duration(this.waitTime, 'seconds');
            return (du.minutes() < 10 ? "0"+du.minutes() : du.minutes()) +":"+ (du.seconds() < 10 ? "0" + du.seconds() : du.seconds());
        }else if(this.waitTime < 60*60*24){
            var du = moment.duration(this.waitTime, 'seconds');
            return (du.hours() < 10 ? "0" + du.hours() : du.hours())+":"+(du.minutes() < 10 ? "0"+du.minutes() : du.minutes()) +":"+ (du.seconds() < 10 ? "0" + du.seconds() : du.seconds());
        }else {
            var du = moment.duration(this.waitTime, 'seconds');
            return du.days() + "天"+(du.hours() < 10 ? "0" + du.hours() : du.hours())+":"+(du.minutes() < 10 ? "0"+du.minutes() : du.minutes()) +":"+ (du.seconds() < 10 ? "0" + du.seconds() : du.seconds());
        }
    },

    toString: function () {
        return JSON.stringify(this);
    },

    createMessageID:function () {
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
        return s.join("");
    }

};
export default ChatRoom;
